import {
  coordEntradaGanaderia,
  coordEntradaEspecies,
  coordEntradaAvestruz,
  coordEntradaPorci,
  coordEntradaFelinos,
  coordEntradaCaninos,
  coordEntranaEquinos,
  coordGanaderiaEspecies,
  coordGanaderiaAvestruz,
  coordGanaderiaCaninos,
  coordGanaderiaFelinos,
  coordGanaderiaPorci,
  coordGanaderiaEquinos,
  coordAvestruzCaninos,
  coordFelinosEquinos,
  coordAvestruzEquinos,
  coordAvestruzFelinos,
  coordAvestruzPorci,
  coordCaninosEntrada,
  coordCaninosEquinos,
  coordEquinosEspecies,
  coordEquinosGanaderia,
  coordFelinosCaninos,
  coordPorciFelinos,
  coordPorciCaninos,
  coordPorciEquinos,
  coordEspeciesAvestruz,
  coordEspeciesCaninos,
  coordEspeciesEquinos,
  coordEspeciesFelinos,
  coordEspeciesPorci,
  coordAvestruzEntrada,
  coordFelinosEntrada,
  coordPorciEntrada,
} from "./CoordenadaMapa.js";

import {
  iconoUser,
  marcador1,
  marcador2,
  marcador3,
  marcador4,
  marcador5,
  marcador6,
  marcador7,
  marcador8,
  marcador9,
  marcador10,
  marcador11,
  marcador12,
  marcador13,
  marcador14,
  marcador15,
  marcador16,
  marcador17,
  marcador18,
  marcador19,
  marcador20,
  marcador21,
  marcador22,
  marcador23,
  marcador24,
  marcador25,
  marcador26,
  marcador27,
  marcador28,
  marcador29,
  marcador30,
  marcador31,
  marcador32,
  marcador33,
  marcador34,
  marcador35,
  marcador36,
  marcador37,
  marcador38,
  marcador39,
  marcador40,
  marcador41,
  marcador42,
  marcador43,
  marcador44,
  marcador45,
  marcador46,
  marcador47,
  marcador48,
  marcador49,
  marcador50,
  marcador51,
  marcador52,
  marcador53,
  marcador54,
  marcador55,
  marcador56,
  marcador57,
  marcador58,
  marcador59,
  marcador60,
  marcador61,
  marcador62,
  marcador63,
  marcador64,
  marcardorEnfoqueEntrada,
  marcadorEnfoqueEquinos,
  marcadorAvestruz,
  marcadorBanoGanaderia,
  marcadorCaninos,
  marcadorEquinos,
  marcadorEspecies,
  marcadorFelinos,
  marcadorGanaderia,
  marcadorGranja,
  marcadorParqueadero1,
  marcadorParqueadero2,
  marcadorParqueadero3,
  marcadorPorcicultura,
  marcadorSericultura,
  marcadorBanoEquinos,
  marcadorBanoEspecies,
  marcadorBanoPorci,
  marcadorRestauranteCaninos,
  marcadorRestauranteEquinos,
  marcadorRestauranteEspecies,
  marcadorRestauranteFelinos,
  marcadorRestauranteGanaderia,
  marcadorRestaurantePorci,
} from "./IconosMapa3.js";

const marcadores = {
  1: "Portería Vehículos",
  2: "Parqueadero de Buses",
  3: "Parqueadero de motos y automoviles",
  4: "Taquilla",
  5: "Entrada principal",
  6: "Corral de animales",
  7: "Canopea PANACA",
  8: "Puente Tibetano I.",
  9: "Tienda de recuerdos PANACA",
  10: "Turismo PANACA",
  11: "Oficina de servicio al cliente",
  12: "Usted esta aquí",
  13: "Inicio del recorrido",
  14: "Terminal de transportes",
  15: "Café PANACA",
  16: "Lago de los patos",
  17: "Fonda del Arriero y Estación del Café",
  18: "Estación Ganaderia",
  19: "Corrales de interactividad",
  20: "En el campo está el futuro",
  21: "Planta de producción y venta de Lácteos PANACA",
  22: "Carrusel Ponys",
  23: "Estación Especies Menores",
  24: "\"Chiquimundo\"",
  25: "El museo de huevo",
  26: "Corral del conejo campesino",
  27: "Sin campo no hay ciudad",
  28: "Estación Avestruces",
  29: "Inicio del sendero ecologico \"Los deseos\"",
  30: "Estación de Porcicultura",
  31: "Juégatela en el cerdódromo",
  32: "Biodigestor",
  33: "\"Balcón del Ensueño\"",
  34: "Interactividad Felina",
  35: "Zona de interactividad felina",
  36: "Mirador \"La Fabrica de Nubes\"",
  37: "Estacón de Agroecología y granja integral",
  38: "Estación Canina",
  39: "Instinto, ¡Una aventura Guau!",
  40: "Zona de interactividad Canina",
  41: "Estación Sericultura",
  42: "Sendero \"El Abajo\"",
  43: "Puente Tibetano II",
  44: "Tarabita",
  45: "Sendero \"Los Guaduales\"",
  46: "Puente Largo",
  47: "Estación Equina",
  48: "Salida de Cabalgata",
  49: "Puente al Decameron",
  50: "Auditorio \"Los Arrieros\"",
  51: "Carrusel de Ponys",
  52: "Trapiche \"San Lorenzo\"",
  53: "Travesia, 5 continentes al galope. El Espectacular Mundo del Caballo",
  54: "La Remesa",
  55: "Huerta orgánica",
  56: "Calle Real - Venta de artesanías",
  57: "Sede administrativa",
  58: "Decameron PANACA",
  59: "Salón de convenciones Decamero PANACA",
  60: "Palapas PANACA",
  61: "Fincas PANACA",
  62: "Malocas PANACA",
  63: "Manga de Vaquería",
  64: "Pueblo PANACA"
};
let z = 0;

if (screen.width > 768) {
  z = 2;
}
//Se inserta el mapa en el div con id map
let map = L.map("map", {
  scrollWheelZoom: true,
  center: [0, 0],
  zoom: z,
});
//Con esta instruccion le indicamos a la libreria cual va a ser las imagenes a mostrar al inicio
L.tileLayer(
  `https://grupopanaca.com.co/PortalPanaca/content/img/Mapa/Inicio/{z}/{x}/{y}.jpg`,
  {
    maxZoom: 6,
    markerZoomAnimation: true,
    minZoom: z,
    noWrap: true,
    continuousWorld: false,
    crs: L.CRS.Simple,
  }
).addTo(map);

//Declaracion de variables
let logo = L.icon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoCachos.svg",
  iconSize: [50, 50],
});
let iconoLogo1,
  iconoLogo2,
  iconoLogo3,
  iconoLogo4,
  iconoLogo5,
  iconoLogo6,
  iconoLogo7;

let contadorRuta = 1;
let $cerrarInformacion = document.getElementById("cerrarInformacion");
let $informacion = document.getElementById("informacion");
let $cerrarRuta = document.getElementById("cerrarRuta");
let $botonBuscar = document.getElementById("botonBuscar");
let $containerInformacion = document.getElementById("container-informacion");
let $iconoRuta = document.getElementById("iconoRuta");
let $Inicio = document.getElementById("puntoInicio");
let $Fin = document.getElementById("puntoFin");
let etiquetas = document.querySelectorAll(".descripcion");
let $ruta = document.getElementById("ruta");
let $loader = document.getElementById("loader");
let $loaderMapa = document.querySelector(".ocultarLoader");
let Inicio;
let Fin;

let estaciones = [
  {
    Item1: {
      id: "ganaderia",
      nombreEstacion: "Estación Ganadería",
      descripcion:
        'Encuentra: presentación "En el campo está el futuro";  tienda de helados, quesos y yogures; carrusel de ponys para niños; interactividad: ordeño y alimentos para los animales; coliseo de Ganadería, baños y zonas de descanso. Aprende con PANACA en el aula viva: ¿Cómo hacer cuajada?. (consulta los horarios disponibles www.panaca.co)',
    },
  },
  {
    Item1: {
      id: "especiesmenores",
      nombreEstacion: "Estación Especies Menores",
      descripcion:
        "En la Estación de Especies Menores encontrarás 60 razas de palomas, 40 razas de gallinas, aves ornamentales, patos, gansos, pavos y piscos, además de varias razas de curíes y conejos exóticos como el Cabeza de León, que tiene un pelaje abundante y largo. También encuentras interactividad: corral de conejos y alimentos para los animales; restaurantes; baños y zonas de descanso.",
    },
  },
  {
    Item1: {
      id: "avestruces",
      nombreEstacion: "Estación Avestruces",
      descripcion:
        "Tres de los 6 avestruces que hacen parte de PANACA han sido rescatadas y hoy viven bajo los cuidados de personal capacitado para sus cuidados y protección. Visita la Estación y conoce mucha más información sobre estos curiosos animales.",
    },
  },
  {
    Item1: {
      id: "porcicultura",
      nombreEstacion: "Estación Porcicultura",
      descripcion:
        "La Estación de Porcicultura tiene hermosos cerdos de razas exóticas, desde la vietnamita que sólo alcanza los 30 centímetros de altura, hasta los más grandes de la raza Durac Jersey, que llegan a medir incluso un metro y medio.",
    },
  },
  {
    Item1: {
      id: "felinos",
      nombreEstacion: "Interactividad Felina",
      descripcion:
        " Aquí descubrirás 12 razas exóticas de gatos de todo el planeta: Americanos, Egipcios, Vikingos y exóticos.",
    },
  },
  {
    Item1: {
      id: "granjaIntegral",
      nombreEstacion: "Estación de Agroecología y granja integral",
      descripcion:
        "Durante el recorrido podrás cruzar por la Huerta Aromática para deleitar tu sentido del olfato y descubrir aromas únicos de las plantas medicinales que probablemente le has escuchado mencionar a tus abuelos. Además, encuentra la granja integral, aprende sobre el campo y los espacios adecuados para tener tus plantas en casa. Aprende con PANACA en el aula viva: La cosecha. (consulta los horarios disponibles www.panaca.co).",
    },
  },
  {
    Item1: {
      id: "caninos",
      nombreEstacion: "Estación Canina",
      descripcion:
        "¡La Estación que enamora a todos! Entra a uno de los mejores caniles de Latinoamérica y explora las cavernas donde habitan ejemplares caninos de más de 48 razas diferentes de todo el mundo. ",
    },
  },

  {
    Item1: {
      id: "sericultura",
      nombreEstacion: "Estación de Sericultura",
      descripcion:
        "Conoce el proceso de vida de este sorprendente animal, del cual con su hilo de seda se fabrican las telas más finas del mundo.",
    },
  },
  {
    Item1: {
      id: "equinos",
      nombreEstacion: "Estación Equina",
      descripcion:
        "En nuestra espectacular Estación Equina te encontrarás con aproximadamente 30 razas, representadas en más de 150 ejemplares de diferentes continentes como Asia, África, Europa y América. También encuentras baños, restaurantes, talabartería, salida de la cabalgata, panadería, trapiche, carrusel de ponys, baños y zonas de descanso. Aprende con PANACA en el aula viva: ¿Cómo cuidar el caballo? (consulta los horarios disponibles www.panaca.co)",
    },
  },
  {
    Item1: {
      id: "fincas",
      nombreEstacion: "Fincas PANACA",
      descripcion:
        "En Fincas PANACA tendrás diferentes opciones para alojarte en pareja o en grupos y disfrutar lo mejor de la naturaleza en tu estadía.",
    },
  },
  {
    Item1: {
      id: "hotel",
      nombreEstacion: "Hotel Decameron PANACA",
      descripcion:
        "Aquí encuentras el primer hotel temático agropecuario del mundo, cuya infraestructura está rodeada de un enorme parque natural por el que toma su nombre y que involucra toda la filosofía del campo.",
    },
  },
  {
    Item1: {
      id: "enfoqueEntrada",
      nombreEstacion: "Enfoque",
      descripcion: 
        "¡Aquí puedes comprar tus fotos físicas o dígitales tomadas durante tu experiencia en Panaca!"
    }
  },
  {
    Item1: {
      id: "enfoqueEquinos",
      nombreEstacion: "Enfoque equinos",
      descripcion:
        "¡Aquí puedes comprar tus fotos físicas o dígitales tomadas durante tu experiencia en Panaca!"
    }
  }
];

let restaurantes = [],
  horarios = [];
let grupoNumeros = L.layerGroup([
  marcador1,
  marcador2,
  marcador3,
  marcador4,
  marcador5,
  marcador6,
  marcador7,
  marcador8,
  marcador9,
  marcador10,
  marcador11,
  marcador12,
  marcador13,
  marcador14,
  marcador15,
  marcador16,
  marcador17,
  marcador18,
  marcador19,
  marcador20,
  marcador21,
  marcador22,
  marcador23,
  marcador24,
  marcador25,
  marcador26,
  marcador27,
  marcador28,
  marcador29,
  marcador30,
  marcador31,
  marcador32,
  marcador33,
  marcador34,
  marcador35,
  marcador36,
  marcador37,
  marcador38,
  marcador39,
  marcador40,
  marcador41,
  marcador42,
  marcador43,
  marcador44,
  marcador45,
  marcador46,
  marcador47,
  marcador48,
  marcador49,
  marcador50,
  marcador51,
  marcador52,
  marcador53,
  marcador54,
  marcador55,
  marcador56,
  marcador57,
  marcador58,
  marcador59,
  marcador60,
  marcador61,
  marcador62,
  marcador63,
  marcador64,
  marcadorBanoEquinos,
  marcadorBanoEspecies,
  marcadorBanoPorci,
  marcadorRestauranteCaninos,
  marcadorRestauranteEquinos,
  marcadorBanoGanaderia,
  marcadorRestauranteEspecies,
  marcadorRestauranteFelinos,
  marcadorRestauranteGanaderia,
  marcadorRestaurantePorci,
]);
let arregloMarcadores = [
  "marcador0",
  marcador1,
  marcador2,
  marcador3,
  marcador4,
  marcador5,
  marcador6,
  marcador7,
  marcador8,
  marcador9,
  marcador10,
  marcador11,
  marcador12,
  marcador13,
  marcador14,
  marcador15,
  marcador16,
  marcador17,
  marcador18,
  marcador19,
  marcador20,
  marcador21,
  marcador22,
  marcador23,
  marcador24,
  marcador25,
  marcador26,
  marcador27,
  marcador28,
  marcador29,
  marcador30,
  marcador31,
  marcador32,
  marcador33,
  marcador34,
  marcador35,
  marcador36,
  marcador37,
  marcador38,
  marcador39,
  marcador40,
  marcador41,
  marcador42,
  marcador43,
  marcador44,
  marcador45,
  marcador46,
  marcador47,
  marcador48,
  marcador49,
  marcador50,
  marcador51,
  marcador52,
  marcador53,
  marcador54,
  marcador55,
  marcador56,
  marcador57,
  marcador58,
  marcador59,
  marcador60,
  marcador61,
  marcador62,
  marcador63,
  marcador64,
];
let grupoEstaciones = L.layerGroup([
  marcadorAvestruz,
  marcadorCaninos,
  marcadorEquinos,
  marcadorEspecies,
  marcadorFelinos,
  marcadorGanaderia,
  marcadorGranja,
  marcardorEnfoqueEntrada,
  marcadorEnfoqueEquinos,
  marcadorParqueadero1,
  marcadorParqueadero2,
  marcadorParqueadero3,
  marcadorPorcicultura,
  marcadorSericultura,
]);

//Mediante estas peticiones cargamos en dos arreglos los horarios y los restaurantes
fetch("https://grupopanaca.com.co/webapi/api/horario")
  .then((response) => response.json())
  .then((data) => {
    horarios = data;
  });

fetch("https://grupopanaca.com.co/webapi/api/Restaurante")
  .then((response) => response.json())
  .then((data) => {
    restaurantes = data;
console.log("debe ocultar el loader");
    //ocultarLoader();

    ocultarLoaderMapa();
  });
//Este metodo de la libreria se activa cada que hay un cambio en el zoom del mapa
map.on("zoom", function () {
  let currentZoom = map.getZoom();
  if (currentZoom > 3) {
    crearPopupNumeros();
    map.addLayer(grupoNumeros);
  } else {
    map.removeLayer(grupoNumeros);
  }
});

//Se le asigna a cada uno de los marcadores un evento click para generar los popus
marcadorGanaderia.on("click", function (e) {
  agregarEventos("Estación Ganadería", marcadorGanaderia);
});
marcadorEspecies.on("click", function (e) {
  agregarEventos("Estación Especies Menores", marcadorEspecies);
});
marcadorAvestruz.on("click", function (e) {
  agregarEventos("Estación Avestruces", marcadorAvestruz);
});
marcadorPorcicultura.on("click", function (e) {
  agregarEventos("Estación Porcicultura", marcadorPorcicultura);
});
marcadorFelinos.on("click", function (e) {
  agregarEventos("Interactividad Felina", marcadorFelinos);
});
marcadorCaninos.on("click", function (e) {
  agregarEventos("Estación Canina", marcadorCaninos);
});
marcadorGranja.on("click", function (e) {
  agregarEventos("Estación de Agroecología y granja integral", marcadorGranja);
});
marcadorEquinos.on("click", function (e) {
  agregarEventos("Estación Equina", marcadorEquinos);
});
marcadorSericultura.on("click", function (e) {
  agregarEventos("Estación de Sericultura", marcadorSericultura);
});
marcardorEnfoqueEntrada.on("click", function (e) {
  agregarEventos("Enfoque", marcardorEnfoqueEntrada);
});
marcadorEnfoqueEquinos.on("click", function (e) {
  agregarEventos("Enfoque equinos", marcadorEnfoqueEquinos);
});
(function () {
  grupoEstaciones.addTo(map);
})();

function limitesMapa() {
  let lat = [0, 15000],
    lng = [16000, 1000];

  map.setMaxBounds(
    new L.LatLngBounds(
      map.unproject(lat, map.getMaxZoom()),
      map.unproject(lng, map.getMaxZoom())
    )
  );
}
limitesMapa();
coordenada();

function coordenada() {
  map.on("click", function (e) {
    console.log(e.latlng);
  });
}
let temp2 = 0;

let n, id, des, conten, popup;

function crearPopup(nombre, marcador) {
  marcador.unbindPopup();
  estaciones.forEach((estacion) => {
    if (nombre == estacion.Item1.nombreEstacion) {
      n = estacion.Item1.nombreEstacion;
      id = estacion.Item1.id;
      des = estacion.Item1.descripcion;

      conten =
        '<b><a href="https://panaca.co/pages/estaciones#' +
        id +
        '"' +
        ' target="blank">' +
        n +
        "</a></b><p>" +
        des +
        "</p>";

      popup = L.popup({ closeButton: false }).setContent(conten);
      marcador.bindPopup(popup).openPopup();
    }
  });
}

function crearPopupNumeros() {

 arregloMarcadores.forEach((marcador, index) => {

    if (index > 0) {
      marcador.on("click", function (e) {
        //let contenidoPopup = document.getElementById(`${index}`);
        //let contenido = contenidoPopup.childNodes[3].textContent;

        marcador.unbindPopup();
        let popupNumero = L.popup({ closeButton: false }).setContent(marcadores[index]);
        marcador.bindPopup(popupNumero).openPopup();
      });
    }
  });
}

document.addEventListener("click", (e) => {
  if (e.target.classList.contains("irMapa")) {
    let padre = e.target.parentNode;
    let id = padre.id;
    let coorde = arregloMarcadores[id]._latlng;

    coorde = [Object.values(coorde)];

    map.fitBounds(coorde, { maxZoom: 6 });
    location.href = "https://panaca.co/pages/mapa#subir";
  }
});

function peticion(clic) {
  obtenerHorarios(clic);
  ObtenerRestaurantes(clic);
}

function obtenerHorarios(clic) {
  horarios.forEach((horario) => {
    if (
      horario.Item3.ubicacionNombre == Fin ||
      horario.Item3.ubicacionNombre == clic
    ) {
      let divTarjeta = document.createElement("div");
      divTarjeta.className = "tarjetasHorarios";
      divTarjeta.id = horario.Item1.eventoID;
      $informacion.append(divTarjeta);
      document.getElementById(horario.Item1.eventoID).innerHTML =
        `` +
        `<div class="tituloTarjetaHorarios">` +
        `<p class="tituloEstacion">` +
        horario.Item3.ubicacionNombre +
        `</p>` +
        `</div>` +
        `<div class="descripcionTarjetaHorarios">` +
        `<div class="tituloDescripcion">` +
        `Presentacion: ` +
        horario.Item1.eventoNombre +
        `</div>` +
        `<div class="descripcionHorario">` +
        `Duración: ` +
        horario.Item1.duracion +
        `<br>` +
        `<div id="horario-` +
        horario.Item1.eventoID +
        `"></div>` +
        `</div>` +
        `</div>`;
      let divisor = " ";
      horario.Item2.forEach(function (item2) {
        if (item2.permanente === false) {
          let spanHorario = document.createElement("span");
          spanHorario.textContent =
            divisor +
            (item2.horaInicio > 12 ? item2.horaInicio - 12 : item2.horaInicio) +
            ":" +
            (item2.minutoInicio == 0 ? "00" : item2.minutoInicio) +
            " " +
            item2.formato;
          document
            .getElementById("horario-" + horario.Item1.eventoID)
            .append(spanHorario);
          divisor = " - ";
        }
      });
    }
  });
}

function ObtenerRestaurantes(clic) {
  restaurantes.forEach((estacion, index) => {
    if (Fin == estacion.Ubicacion || clic == estacion.Ubicacion) {
      const divPadre = document.createElement("div");
      divPadre.className = "restaurante";
      $informacion.append(divPadre);

      const div = document.createElement("div");
      div.className = "tituloEstacion";
      div.textContent = "Restaurante";
      div.id = estacion.Ubicacion + index;
      divPadre.appendChild(div);

      estacion.RestauranteIDRestaurante_PlatoIDNombreDescripcionPrecioList.forEach(
        (Restaurantes) => {
          const divRestaurante = document.createElement("div");
          divRestaurante.className = "";
          divRestaurante.id = "informacion-" + Restaurantes.Item2 + index;
          document.getElementById(div.id).append(divRestaurante);
          document.getElementById(divRestaurante.id).innerHTML =
            `` +
            `<div onclick="MostrarMenuRestaurante(${estacion.UbicacionID}, ${Restaurantes.Item1})" class="text-sm border-b-2 border-[#4d3419] md:flex items-end justify-between cursor-pointer py-3 hover:text-red-600">` +
            `<p class="font-bold text-[#4d3419]">${Restaurantes.Item2}</p>` +
            `<p class="text-sm verMas">Ver Más</p>` +
            `</div>`;
        }
      );
      let divLink = document.createElement("div");
      divLink.className = "";
      divLink.id = "link";
      $informacion.append(divLink);
      let link = "https://panaca.co/pages/estaciones#";
      let a = document.createElement("a");
      divLink.append(a);
      a.target = "blank";
      a.textContent = "Conoce mas sobre la Estacion";
      if (estacion.Ubicacion == "Estación Ganadería") {
        a.href = link + "ganaderia";
      }
      if (estacion.Ubicacion == "Estación Especies Menores") {
        a.href = link + "especiesmenores";
      }
      if (estacion.Ubicacion == "Estación Porcicultura") {
        a.href = link + "porcicultura";
      }
      if (estacion.Ubicacion == "Interactividad Felina") {
        a.href = link + "estacionfelina";
      }
      if (estacion.Ubicacion == "Estación Canina") {
        a.href = link + "estacioncanina";
      }
      if (estacion.Ubicacion == "Estación Equina") {
        a.href = link + "estacionequina";
      }
    }
  });

  // console.log(data)
}
let ruta = 0;

$iconoRuta.addEventListener("click", () => {
  Inicio = "";
  Fin = "";
  if (ruta == 0) {
    $ruta.style.display = "block";
  }

  if (ruta > 0) {
    $informacion.style.display = "none";
    $ruta.style.display = "block";
    L.tileLayer(
      `https://grupopanaca.com.co/PortalPanaca/content/img/Mapa/Inicio/{z}/{x}/{y}.jpg`,
      {
        maxZoom: 6,
        markerZoomAnimation: true,
        minZoom: 0,
        noWrap: true,

        continuousWorld: false,
        crs: L.CRS.Simple,
      }
    ).addTo(map);

    map.fitBounds([[3.9164794795307856, -15.115148562820028]], {
      maxZoom: 3,
    });

    if (contadorRuta == 1) {
      iconoLogo1.remove();
    }
    if (contadorRuta == 2) {
      iconoLogo2.remove();
    }
    if (contadorRuta == 3) {
      iconoLogo3.remove();
    }
    if (contadorRuta == 4) {
      iconoLogo4.remove();
    }
    if (contadorRuta == 5) {
      iconoLogo5.remove();
    }
    if (contadorRuta == 6) {
      iconoLogo6.remove();
    }
    if (contadorRuta == 7) {
      iconoLogo7.remove();
    }
    if (contadorRuta == 8) {
      iconoLogo7.remove();
    }
    if (contadorRuta == 9) {
      iconoLogo7.remove();
    }
    if (contadorRuta == 10) {
      iconoLogo7.remove();
    }
    contadorRuta++;
  }
});
$cerrarInformacion.addEventListener("click", () => {
  $informacion.style.display = "none";
  $cerrarInformacion.style.display = "none";
});
$botonBuscar.addEventListener("click", () => {
  Inicio = $Inicio.value;
  Fin = $Fin.value;

  $ruta.style.display = "none";

  if (Inicio == null || Fin == null) {
    alert("Por favor seleccione los dos puntos");
  } else {
    if (Inicio == "Inicio de la Aventura" || Fin == "Inicio de la Aventura") {
      if (
        (Inicio == "Inicio de la Aventura" && Fin == "Estación Ganadería") ||
        (Inicio == "Estación Ganadería" && Fin == "Inicio de la Aventura")
      ) {
        if (Inicio == "Inicio de la Aventura") {
          crearRuta("entradaGanaderia", coordEntradaGanaderia, true);
        } else {
          crearRuta("entradaGanaderia", coordEntradaGanaderia, false);
        }
      }
      if (
        (Inicio == "Inicio de la Aventura" &&
          Fin == "Estación Especies Menores") ||
        (Inicio == "Estación Especies Menores" &&
          Fin == "Inicio de la Aventura")
      ) {
        if (Inicio == "Inicio de la Aventura") {
          crearRuta("entradaEspecies", coordEntradaEspecies, true);
        } else {
          crearRuta("entradaEspecies", coordEntradaEspecies, false);
        }
      }
      if (
        (Inicio == "Inicio de la Aventura" && Fin == "Estación Avestruces") ||
        (Inicio == "Estación Avestruces" && Fin == "Inicio de la Aventura")
      ) {
        if (Inicio == "Inicio de la Aventura") {
          crearRuta("entradaAvestruz", coordEntradaAvestruz, true);
        } else {
          crearRuta("avestruzEntrada", coordAvestruzEquinos, true);
        }
      }
      if (
        (Inicio == "Inicio de la Aventura" && Fin == "Estación Porcicultura") ||
        (Inicio == "Estación Porcicultura" && Fin == "Inicio de la Aventura")
      ) {
        if (Inicio == "Inicio de la Aventura") {
          crearRuta("entradaPorci", coordEntradaPorci, true);
        } else {
          crearRuta("porciEntrada", coordPorciEntrada, true);
        }
      }
      if (
        (Inicio == "Inicio de la Aventura" && Fin == "Interactividad Felina") ||
        (Inicio == "Interactividad Felina" && Fin == "Inicio de la Aventura")
      ) {
        if (Inicio == "Inicio de la Aventura") {
          crearRuta("entradaFelinos", coordEntradaFelinos, true);
        } else {
          crearRuta("felinosEntrada", coordFelinosEntrada, true);
        }
      }
      if (
        (Inicio == "Inicio de la Aventura" && Fin == "Estación Canina") ||
        (Inicio == "Estación Canina" && Fin == "Inicio de la Aventura")
      ) {
        if (Inicio == "Inicio de la Aventura") {
          crearRuta("entradaCaninos", coordEntradaCaninos, true);
        } else {
          crearRuta("caninosEntrada", coordCaninosEntrada, true);
        }
      }
      if (
        (Inicio == "Inicio de la Aventura" && Fin == "Estación Equina") ||
        (Inicio == "Estación Equina" && Fin == "Inicio de la Aventura")
      ) {
        if (Inicio == "Inicio de la Aventura") {
          crearRuta("equinosEntrada", coordEntranaEquinos, true);
        } else {
          crearRuta("equinosEntrada", coordEntranaEquinos, false);
        }
      }
    }
    if (Inicio == "Estación Ganadería" || Fin == "Estación Ganadería") {
      if (
        (Inicio == "Estación Ganadería" &&
          Fin == "Estación Especies Menores") ||
        (Inicio == "Estación Especies Menores" && Fin == "Estación Ganadería")
      ) {
        if (Inicio == "Estación Ganadería") {
          crearRuta("ganaderiaEspecies", coordGanaderiaEspecies, true);
        } else {
          crearRuta("ganaderiaEspecies", coordGanaderiaEspecies, false);
        }
      }
      if (
        (Inicio == "Estación Ganadería" && Fin == "Estación Avestruces") ||
        (Inicio == "Estación Avestruces" && Fin == "Estación Ganadería")
      ) {
        if (Inicio == "Estación Ganadería") {
          crearRuta("ganaderiaAvestruz", coordGanaderiaAvestruz, true);
        } else {
          crearRuta("ganaderiaAvestruz", coordGanaderiaAvestruz, false);
        }
      }
      if (
        (Inicio == "Estación Ganadería" && Fin == "Estación Porcicultura") ||
        (Inicio == "Estación Porcicultura" && Fin == "Estación Ganadería")
      ) {
        if (Inicio == "Estación Ganadería") {
          crearRuta("ganaderiaPorci", coordGanaderiaPorci, true);
        } else {
          crearRuta("ganaderiaPorci", coordGanaderiaPorci, false);
        }
      }
      if (
        (Inicio == "Estación Ganadería" && Fin == "Interactividad Felina") ||
        (Inicio == "Interactividad Felina" && Fin == "Estación Ganadería")
      ) {
        if (Inicio == "Estación Ganadería") {
          crearRuta("ganaderiaFelinos", coordGanaderiaFelinos, true);
        } else {
          crearRuta("ganaderiaFelinos", coordGanaderiaFelinos, false);
        }
      }
      if (
        (Inicio == "Estación Ganadería" && Fin == "Estación Canina") ||
        (Inicio == "Estación Canina" && Fin == "Estación Ganadería")
      ) {
        if (Inicio == "Estación Ganadería") {
          crearRuta("ganaderiaCaninos", coordGanaderiaCaninos, true);
        } else {
          crearRuta("ganaderiaCaninos", coordGanaderiaCaninos, false);
        }
      }
      if (
        (Inicio == "Estación Ganadería" && Fin == "Estación Equina") ||
        (Inicio == "Estación Equina" && Fin == "Estación Ganadería")
      ) {
        if (Inicio == "Estación Ganadería") {
          crearRuta("ganaderiaEquinos", coordGanaderiaEquinos, true);
        } else {
          crearRuta("equinosGanaderia", coordEquinosGanaderia, true);
        }
      }
    }
    if (
      Inicio == "Estación Especies Menores" ||
      Fin == "Estación Especies Menores"
    ) {
      if (
        (Inicio == "Estación Especies Menores" &&
          Fin == "Estación Avestruces") ||
        (Inicio == "Estación Avestruces" && Fin == "Estación Especies Menores")
      ) {
        if (Inicio == "Estación Especies Menores") {
          crearRuta("especiesAvestruz", coordEspeciesAvestruz, true);
        } else {
          crearRuta("especiesAvestruz", coordEspeciesAvestruz, false);
        }
      }
      if (
        (Inicio == "Estación Especies Menores" &&
          Fin == "Estación Porcicultura") ||
        (Inicio == "Estación Porcicultura" &&
          Fin == "Estación Especies Menores")
      ) {
        if (Inicio == "Estación Especies Menores") {
          crearRuta("especiesPorci", coordEspeciesPorci, true);
        } else {
          crearRuta("especiesPorci", coordEspeciesPorci, false);
        }
      }
      if (
        (Inicio == "Estación Especies Menores" && Fin == "Interactividad Felina") ||
        (Inicio == "Interactividad Felina" && Fin == "Estación Especies Menores")
      ) {
        if (Inicio == "Estación Especies Menores") {
          crearRuta("especiesFelinos", coordEspeciesFelinos, true);
        } else {
          crearRuta("especiesFelinos", coordEspeciesFelinos, false);
        }
      }
      if (
        (Inicio == "Estación Especies Menores" && Fin == "Estación Canina") ||
        (Inicio == "Estación Canina" && Fin == "Estación Especies Menores")
      ) {
        if (Inicio == "Estación Especies Menores") {
          crearRuta("especiesCaninos", coordEspeciesCaninos, true);
        } else {
          crearRuta("especiesCaninos", coordEspeciesCaninos, false);
        }
      }
      if (
        (Inicio == "Estación Especies Menores" && Fin == "Estación Equina") ||
        (Inicio == "Estación Equina" && Fin == "Estación Especies Menores")
      ) {
        if (Inicio == "Estación Especies Menores") {
          crearRuta("especiesEquinos", coordEspeciesEquinos, true);
        } else {
          crearRuta("equinosEspecies", coordEquinosEspecies, true);
        }
      }
    }
    if (Inicio == "Estación Avestruces" || Fin == "Estación Avestruces") {
      if (
        (Inicio == "Estación Avestruces" && Fin == "Estación Porcicultura") ||
        (Inicio == "Estación Porcicultura" && Fin == "Estación Avestruces")
      ) {
        if (Inicio == "Estación Avestruces") {
          crearRuta("avestruzPorci", coordAvestruzPorci, true);
        } else {
          crearRuta("avestruzPorci", coordAvestruzPorci, false);
        }
      }
      if (
        (Inicio == "Estación Avestruces" && Fin == "Interactividad Felina") ||
        (Inicio == "Interactividad Felina" && Fin == "Estación Avestruces")
      ) {
        if (Inicio == "Estación Avestruces") {
          crearRuta("avestruzFelinos", coordAvestruzFelinos, true);
        } else {
          crearRuta("avestruzFelinos", coordAvestruzFelinos, false);
        }
      }
      if (
        (Inicio == "Estación Avestruces" && Fin == "Estación Canina") ||
        (Inicio == "Estación Canina" && Fin == "Estación Avestruces")
      ) {
        if (Inicio == "Estación Avestruces") {
          crearRuta("avestruzCaninos", coordAvestruzCaninos, true);
        } else {
          crearRuta("avestruzCaninos", coordAvestruzCaninos, false);
        }
      }
      if (
        (Inicio == "Estación Avestruces" && Fin == "Estación Equina") ||
        (Inicio == "Estación Equina" && Fin == "Estación Avestruces")
      ) {
        if (Inicio == "Estación Avestruces") {
          crearRuta("avestruzEquinos", coordAvestruzEquinos, true);
        } else {
          crearRuta("avestruzEquinos", coordAvestruzEquinos, false);
        }
      }
    }
    if (Inicio == "Estación Porcicultura" || Fin == "Estación Porcicultura") {
      if (
        (Inicio == "Estación Porcicultura" && Fin == "Interactividad Felina") ||
        (Inicio == "Interactividad Felina" && Fin == "Estación Porcicultura")
      ) {
        if (Inicio == "Estación Porcicultura") {
          crearRuta("porciFelinos", coordPorciFelinos, true);
        } else {
          crearRuta("porciFelinos", coordPorciFelinos, false);
        }
      }
      if (
        (Inicio == "Estación Porcicultura" && Fin == "Estación Canina") ||
        (Inicio == "Estación Canina" && Fin == "Estación Porcicultura")
      ) {
        if (Inicio == "Estación Porcicultura") {
          crearRuta("porciCaninos", coordPorciCaninos, true);
        } else {
          crearRuta("porciCaninos", coordPorciCaninos, false);
        }
      }
      if (
        (Inicio == "Estación Porcicultura" && Fin == "Estación Equina") ||
        (Inicio == "Estación Equina" && Fin == "Estación Porcicultura")
      ) {
        if (Inicio == "Estación Porcicultura") {
          crearRuta("porciEquinos", coordPorciEquinos, true);
        } else {
          crearRuta("porciEquinos", coordPorciEquinos, false);
        }
      }
    }
    if (Inicio == "Interactividad Felina" || Fin == "Interactividad Felina") {
      if (
        (Inicio == "Interactividad Felina" && Fin == "Estación Canina") ||
        (Inicio == "Estación Canina" && Fin == "Interactividad Felina")
      ) {
        if (Inicio == "Interactividad Felina") {
          crearRuta("felinosCaninos", coordFelinosCaninos, true);
        } else {
          crearRuta("felinosCaninos", coordFelinosCaninos, false);
        }
      }
      if (
        (Inicio == "Interactividad Felina" && Fin == "Estación Equina") ||
        (Inicio == "Estación Equina" && Fin == "Interactividad Felina")
      ) {
        if (Inicio == "Interactividad Felina") {
          crearRuta("felinosEquinos", coordFelinosEquinos, true);
        } else {
          crearRuta("felinosEquinos", coordFelinosEquinos, false);
        }
      }
    }
    if (Inicio == "Estación Canina" || Fin == "Estación Canina") {
      if (
        (Inicio == "Estación Canina" && Fin == "Estación Equina") ||
        (Inicio == "Estación Equina" && Fin == "Estación Canina")
      ) {
        if (Inicio == "Estación Canina") {
          crearRuta("caninosEquinos", coordCaninosEquinos, true);
        } else {
          crearRuta("caninosEquinos", coordCaninosEquinos, false);
        }
      }
    }

    $informacion.innerHTML = "";
    peticion();

    $informacion.style.display = "block";
  }

  ruta++;
});

function crearRuta(ruta, coordenadas, start) {
  console.log(`la ruta => https://grupopanaca.com.co/PortalPanaca/content/img/Mapa/${ruta}/{z}/{x}/{y}.jpg`)
  L.tileLayer(
    `https://grupopanaca.com.co/PortalPanaca/content/img/Mapa/${ruta}/{z}/{x}/{y}.jpg`,
    {
      maxZoom: 6,
      markerZoomAnimation: true,
      minZoom: 0,
      noWrap: true,

      continuousWorld: false,
      crs: L.CRS.Simple,
    }
  ).addTo(map);

  map.fitBounds(coordenadas, {
    maxZoom: 5,
  });

  let tiempos = [];
  for (let index = 0; index < coordenadas.length; index++) {
    tiempos.push(500);
  }
  if (contadorRuta == 1) {
    if (start) {
      iconoLogo1 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo1.start();
    } else {
      coordenadas.reverse();
      iconoLogo1 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo1.start();
    }
  }
  if (contadorRuta == 2) {
    if (start) {
      iconoLogo2 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo2.start();
    } else {
      coordenadas.reverse();
      iconoLogo2 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo2.start();
    }
  }
  if (contadorRuta == 3) {
    if (start) {
      iconoLogo3 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo3.start();
    } else {
      coordenadas.reverse();
      iconoLogo3 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo3.start();
    }
  }
  if (contadorRuta == 4) {
    if (start) {
      iconoLogo4 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo4.start();
    } else {
      coordenadas.reverse();
      iconoLogo4 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo4.start();
    }
  }
  if (contadorRuta == 5) {
    if (start) {
      iconoLogo5 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo5.start();
    } else {
      coordenadas.reverse();
      iconoLogo5 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo5.start();
    }
  }
  if (contadorRuta == 6) {
    if (start) {
      iconoLogo6 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo6.start();
    } else {
      coordenadas.reverse();
      iconoLogo6 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo6.start();
    }
  }
  if (contadorRuta == 7) {
    if (start) {
      iconoLogo7 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo7.start();
    } else {
      coordenadas.reverse();
      iconoLogo7 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo7.start();
    }
  }
  if (contadorRuta == 8) {
    if (start) {
      iconoLogo8 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo8.start();
    } else {
      coordenadas.reverse();
      iconoLogo8 = L.Marker.movingMarker(coordenadas, tiempos, {
        loop: true,
        icon: logo,
      }).addTo(map);
      iconoLogo8.start();
    }
  }
}

$cerrarRuta.addEventListener("click", () => {
  $ruta.style.display = "none";
});
function agregarEventos(estacion, marcador) {
  Fin = "";
  Inicio = "";

  $informacion.innerHTML = "";
  $informacion.style.display = "block";
  $cerrarInformacion.style.display = "block";
  crearPopup(estacion, marcador);
  peticion(estacion);
}

if (window.location.toString().includes("?")) {
  let url = window.location.toString().split("?");
  let idUbicacion = url[1].split("=")[1];

  fetch("https://grupopanaca.com.co/webapi/api/ubicaciones")
    .then((response) => response.json())
    .then((data) => {
      qrMapa(data, idUbicacion);
    });
}
function qrMapa(data, id) {
  data.forEach((ubicacion) => {
    if (ubicacion.ubicacionID == id) {
      let coord = ubicacion.coordenada.split(",");
      for (let index = 0; index < coord.length; index++) {
        coord[index] = parseFloat(coord[index]);
      }
      let marcadorser = L.marker(coord, {
        icon: iconoUser,
      }).addTo(map);
      let ruta = "<p>¡Usted esta aquí!</p>";
      let popupMapa = L.popup().setContent(ruta);
      marcadorser.bindPopup(popupMapa).openPopup();
      map.fitBounds([coord], {
        maxZoom: 5,
      });
    }
  });
}

function ocultarLoaderMapa() {
  $loaderMapa.style.display = "none";
}
